import { getLocale } from '../../utils/pathHelper';

type TranslationKeys =
'add'|
'adultNum'|
  'childNum' |
'studentNum'|
  'middleSchoolStudentNum' |
'seniorNum'|
  'ageOverSixtyNum' |
'days'|
'voucherNum'|
'dateOfUse'|
'startDate'|
'timeSchedule'|
'addToCart'|
'purchase'|
'pickupPlace'|
'childPriceIsAppliedToPersonUnderAgeOf'|
'pleaseSelect'|
'pleaseSelectNumberOfTicketsAndDateOfUse'|
'pleaseSelectValidNumberOfParticipants'|
'vouchersWillBeIssuedForDays'|
'vouchersWillBeAddedToCartForDays'|
'price'|
'passenger'|
'firstName'|
'lastName'|
'firstNamePlaceholder'|
'lastNamePlaceholder'|
'limit'|
'required'|
'valueMissingError'|
'patternMismatchError'|
'icCardDeposit'|
'icCardDepositNote'|
'useCoupon'|
'enterCouponCode'|
'couponDiscount'|
'selectNumOfPeopleAndDate'|
'paymentTotal'|
'groupPrice'

type TranslationLocales = 'en'|'ja'|'zh-CN'|'zh-HK'|'zh-TW';

export type ITranslation = {
  [key in TranslationKeys]: ({}?: { [arg: string]: string|number }) => string;
}

const locales: {
  [locale in TranslationLocales]: ITranslation
} = {
  'en': {
    groupPrice: () => ('Group price'),
    paymentTotal: () => ('Payment total'),
    add: () => ('Add'),
    selectNumOfPeopleAndDate: () => ('Select the number of people and date'),
    useCoupon: () => ('Use a coupon'),
    enterCouponCode: () => ('Enter the coupon code'),
    couponDiscount: () => ('Coupon discount'),
    icCardDeposit: () => ('IC card deposit'),
    icCardDepositNote: () => ('*Deposit will be issued when the IC card is returned'),
    adultNum: () => ('Adult'),
    childNum: () => ('Child'),
    studentNum: () => ('Student'),
    middleSchoolStudentNum: () => ('Middle school student'),
    seniorNum: () => ('Senior'),
    ageOverSixtyNum: () => ('Senior (60+)'),
    days: () => ('Day(s)'),
    voucherNum: () => ('Pass(es)'),
    dateOfUse: () => ('Date of use'),
    startDate: () => ('Start Date'),
    timeSchedule: () => ('Time'),
    addToCart: () => ('Add to cart'),
    purchase: () => ('Buy'),
    pickupPlace: () => ('Pickup Location'),
    childPriceIsAppliedToPersonUnderAgeOf: ({ age }) => (`Child price is valid for ${age} and under.`),
    pleaseSelect: () => ('Please select'),
    pleaseSelectNumberOfTicketsAndDateOfUse: () => ('Please select amount and date'),
    pleaseSelectValidNumberOfParticipants: (
      { max }: { max: number }) => (`The total number of people must not exceed ${max} people.`),
    vouchersWillBeIssuedForDays: ({
      numberOfDays, dateDuration, numberOfVouchers }: {
      numberOfDays: number, dateDuration: number, numberOfVouchers: number
    }) => {
      const dayUnit = numberOfDays === 1 ? 'day' : 'days';
      const durationUnit = dateDuration === 1 ? 'day' : 'days';
      const voucherUnit = numberOfVouchers === 1 ? 'sheet' : 'sheets';
      return `The voucher will be issued for ${numberOfDays} ${dayUnit}
        (${dateDuration} ${durationUnit} ticket, ${numberOfVouchers} ${voucherUnit}).`
    },
    vouchersWillBeAddedToCartForDays: ({
      numberOfDays, dateDuration, numberOfVouchers }: {
      numberOfDays: number, dateDuration: number, numberOfVouchers: number
    }) => {
      const dayUnit = numberOfDays === 1 ? 'day' : 'days';
      const durationUnit = dateDuration === 1 ? 'day' : 'days';
      const voucherUnit = numberOfVouchers === 1 ? 'sheet' : 'sheets';
      return `The voucher of ${numberOfDays} ${dayUnit}
        (${dateDuration} ${durationUnit} pass, ${numberOfVouchers} ${voucherUnit}) will be added to your cart.`
    },
    // JRW
    price: () => ('Price'),
    passenger: () => ('Passenger'),
    firstName: () => ('First name'),
    lastName: () => ('Last name'),
    firstNamePlaceholder: () => ('e.g. JOHN'),
    lastNamePlaceholder: () => ('e.g. SMITH'),
    limit: () => ('Max. 10 per order'),
    required: () => ('Required'),
    valueMissingError: () => ('Please fill in the required item'),
    patternMismatchError: () => ('Please use half-width English characters')
  },
  'ja': {
    groupPrice: () => ('グループ料金'),
    paymentTotal: () => ('支払い合計'),
    add: () => ('追加'),
    selectNumOfPeopleAndDate: () => ('人数と日付を選択'),
    useCoupon: () => ('クーポンを使用'),
    enterCouponCode: () => ('クーポンコードを入力'),
    couponDiscount: () => ('クーポン適用'),
    icCardDeposit: () => ('ICカード保証金'),
    icCardDepositNote: () => ('※ICカード返却時に返金されます'),
    adultNum: () => ('大人'),
    childNum: () => ('子供'),
    studentNum: () => ('学生'),
    middleSchoolStudentNum: () => ('中高生'),
    seniorNum: () => ('シニア'),
    ageOverSixtyNum: () => ('60歳以上'),
    days: () => ('日分'),
    voucherNum: () => ('枚'),
    dateOfUse: () => ('利用日'),
    startDate: () => ('利用開始日'),
    timeSchedule: () => ('利用時間'),
    addToCart: () => ('カートに追加'),
    purchase: () => ('購入する'),
    pickupPlace: () => ('チケットの受け取り場所'),
    childPriceIsAppliedToPersonUnderAgeOf: ({ age }) => (`子供料金の適応は${age}歳以下です。`),
    pleaseSelect: () => ('選択してください'),
    pleaseSelectNumberOfTicketsAndDateOfUse: () => ('枚数と日付を選択してください。'),
    pleaseSelectValidNumberOfParticipants: (
      { max }: { max: number }) => (`合計で${max}人以内になるように人数を選択してください。`),
    vouchersWillBeIssuedForDays: ({
      numberOfDays, dateDuration, numberOfVouchers }: {
      numberOfDays: number, dateDuration: number, numberOfVouchers: number
    }) => (`${numberOfDays}日分のバウチャー(${dateDuration}日券 x ${numberOfVouchers}枚)が発行されます。`),
    vouchersWillBeAddedToCartForDays: ({
      numberOfDays, dateDuration, numberOfVouchers }: {
      numberOfDays: number, dateDuration: number, numberOfVouchers: number
    }) => (`${numberOfDays}日分のバウチャー(${dateDuration}日券 x ${numberOfVouchers}枚)がカートに追加されます。`),
    // JRW
    price: () => ('料金'),
    passenger: () => ('搭乘客'),
    firstName: () => ('名（半角ローマ字）'),
    lastName: () => ('姓（半角ローマ字）'),
    firstNamePlaceholder: () => ('例：TARO'),
    lastNamePlaceholder: () => ('例：YAMADA'),
    limit: () => ('1注文あたり最大10枚まで'),
    required: () => ('必須'),
    valueMissingError: () => ('必須項目を入力してください'),
    patternMismatchError: () => ('半角ローマ字で入力してください')
  },
  'zh-CN': {
    groupPrice: () => ('团体费用'),
    paymentTotal: () => ('支付总额'),
    add: () => ('添加'),
    selectNumOfPeopleAndDate: () => ('选择日期与人数'),
    useCoupon: () => ('使用优惠券'),
    enterCouponCode: () => ('输入优惠券代码'),
    couponDiscount: () => ('优惠券优惠'),
    icCardDeposit: () => ('电子卡押金'),
    icCardDepositNote: () => ('※归还电子卡时将退还押金'),
    adultNum: () => ('成人'),
    childNum: () => ('儿童'),
    studentNum: () => ('学生'),
    middleSchoolStudentNum: () => ('中学生'),
    seniorNum: () => ('老年人'),
    ageOverSixtyNum: () => ('60岁及以上'),
    days: () => ('天份'),
    voucherNum: () => ('张'),
    dateOfUse: () => ('使用日期'),
    startDate: () => ('开始使用日'),
    timeSchedule: () => ('时段'),
    addToCart: () => ('加进购物车'),
    purchase: () => ('购买'),
    pickupPlace: () => ('取票地点'),
    childPriceIsAppliedToPersonUnderAgeOf: ({ age }) => (`适用儿童价格的年龄为${age}以下。`),
    pleaseSelect: () => ('请选择'),
    pleaseSelectNumberOfTicketsAndDateOfUse: () => ('请选择张数及日期。'),
    pleaseSelectValidNumberOfParticipants: (
      { max }: { max: number }) => (`请选择总和${max}位以内的人。`),
    vouchersWillBeIssuedForDays: ({
      numberOfDays, dateDuration, numberOfVouchers }: {
      numberOfDays: number, dateDuration: number, numberOfVouchers: number
    }) => (`将发行${numberOfDays}天份的兑换券（${dateDuration}日券 x ${numberOfVouchers}张）。`),
    vouchersWillBeAddedToCartForDays: ({
      numberOfDays, dateDuration, numberOfVouchers }: {
      numberOfDays: number, dateDuration: number, numberOfVouchers: number
    }) => (`${numberOfDays}天份的兑换券（${dateDuration}日券 x ${numberOfVouchers}張）已加进购物车`),
    // JRW
    price: () => ('费用'),
    passenger: () => ('乘客'),
    firstName: () => ('名（半角英文字母）'),
    lastName: () => ('姓（半角英文字母）'),
    firstNamePlaceholder: () => ('例：HONG'),
    lastNamePlaceholder: () => ('例：WANG'),
    limit: () => ('最多可购买10张'),
    required: () => ('必填'),
    valueMissingError: () => ('必填项目不得为空'),
    patternMismatchError: () => ('请填写半角英文字母')
  },
  'zh-HK': {
    groupPrice: () => ('團體價錢'),
    paymentTotal: () => ('支付總額'),
    add: () => ('套用'),
    selectNumOfPeopleAndDate: () => ('選擇人數與日期'),
    useCoupon: () => ('使用折扣券'),
    enterCouponCode: () => ('輸入優惠碼'),
    couponDiscount: () => ('折扣券折扣'),
    icCardDeposit: () => ('電子卡按金'),
    icCardDepositNote: () => ('※歸還電子卡時將退回按金'),
    adultNum: () => ('成人'),
    childNum: () => ('小童'),
    studentNum: () => ('學生'),
    middleSchoolStudentNum: () => ('中學生'),
    seniorNum: () => ('長者'),
    ageOverSixtyNum: () => ('60歲或以上'),
    days: () => ('天份'),
    voucherNum: () => ('張'),
    dateOfUse: () => ('使用日期'),
    startDate: () => ('開始使用日'),
    timeSchedule: () => ('時段'),
    addToCart: () => ('加入購物車'),
    purchase: () => ('購買'),
    pickupPlace: () => ('取票地點'),
    childPriceIsAppliedToPersonUnderAgeOf: ({ age }) => (`${age}歲以下按照兒童票價收費。`),
    pleaseSelect: () => ('請選擇'),
    pleaseSelectNumberOfTicketsAndDateOfUse: () => ('請選擇日期與張數。'),
    pleaseSelectValidNumberOfParticipants: (
      { max }: { max: number }) => (`請選擇合共${max}位以內的人數。`),
    vouchersWillBeIssuedForDays: ({
      numberOfDays, dateDuration, numberOfVouchers }: {
      numberOfDays: number, dateDuration: number, numberOfVouchers: number
    }) => (`發行${numberOfDays}日的兌換券(${dateDuration}日券 x ${numberOfVouchers}張)。`),
    vouchersWillBeAddedToCartForDays: ({
      numberOfDays, dateDuration, numberOfVouchers }: {
      numberOfDays: number, dateDuration: number, numberOfVouchers: number
    }) => (`${numberOfDays}日的兌換券(${dateDuration}日券 x ${numberOfVouchers}張)已加入購物車。`),
    // JRW
    price: () => ('費用'),
    passenger: () => ('乘客'),
    firstName: () => ('名（半形英文字母）'),
    lastName: () => ('姓（半形英文字母）'),
    firstNamePlaceholder: () => ('例：CHAN TAI'),
    lastNamePlaceholder: () => ('例：MAN'),
    limit: () => ('最多可購買10張'),
    required: () => ('必填'),
    valueMissingError: () => ('請輸入必填項目'),
    patternMismatchError: () => ('請輸入半形英文字母')
  },
  'zh-TW': {
    groupPrice: () => ('團體費用'),
    paymentTotal: () => ('支付總額'),
    add: () => ('套用'),
    selectNumOfPeopleAndDate: () => ('選擇人數與日期'),
    useCoupon: () => ('使用優惠券'),
    enterCouponCode: () => ('輸入優惠券代碼'),
    couponDiscount: () => ('優惠券折扣'),
    icCardDeposit: () => ('IC卡押金'),
    icCardDepositNote: () => ('※歸還IC卡時將退還押金'),
    adultNum: () => ('成人'),
    childNum: () => ('兒童'),
    studentNum: () => ('學生'),
    middleSchoolStudentNum: () => ('國高中生'),
    seniorNum: () => ('年長者'),
    ageOverSixtyNum: () => ('60歲以上'),
    days: () => ('天份'),
    voucherNum: () => ('張'),
    dateOfUse: () => ('使用日期'),
    startDate: () => ('開始使用日'),
    timeSchedule: () => ('時段'),
    addToCart: () => ('加進購物車'),
    purchase: () => ('購買'),
    pickupPlace: () => ('取票地點'),
    childPriceIsAppliedToPersonUnderAgeOf: ({ age }) => (`適用兒童價格的年齡為${age}以下。`),
    pleaseSelect: () => ('請選擇'),
    pleaseSelectNumberOfTicketsAndDateOfUse: () => ('請選擇張數及日期。'),
    pleaseSelectValidNumberOfParticipants: (
      { max }: { max: number }) => (`請選擇總和${max}位以內的人數。`),
    vouchersWillBeIssuedForDays: ({
      numberOfDays, dateDuration, numberOfVouchers }: {
      numberOfDays: number, dateDuration: number, numberOfVouchers: number
    }) => (`將發行${numberOfDays}天份的兌換券（${dateDuration}日券 x ${numberOfVouchers}張）。`),
    vouchersWillBeAddedToCartForDays: ({
      numberOfDays, dateDuration, numberOfVouchers }: {
      numberOfDays: number, dateDuration: number, numberOfVouchers: number
    }) => (`${numberOfDays}天份的兌換券（${dateDuration}日券 x ${numberOfVouchers}張）已加進購物車。`),
    // JRW
    price: () => ('費用'),
    passenger: () => ('乘客'),
    firstName: () => ('名（半形羅馬字）'),
    lastName: () => ('姓（半形羅馬字）'),
    firstNamePlaceholder: () => ('例：HONG'),
    lastNamePlaceholder: () => ('例：WANG'),
    limit: () => ('最多可購買10張'),
    required: () => ('必填'),
    valueMissingError: () => ('請輸入必填項目'),
    patternMismatchError: () => ('請輸入半形羅馬字')
  },
};

const t: ITranslation = locales[getLocale() || 'en'];

export default t;
